import React from "react";
import { Route, Switch, useRouteMatch } from "react-router-dom";
import { ManageRepaymentOptions, ManageRepaymentsButtonContainer } from "./components";
import { ManageArrearsOptions } from "./containers/ManageArrears/manageArrearsOptions";
import { ManageRepaymentsIncrease } from "./containers/IncreaseRepayments/manageRepaymentsIncrease";
import { MANAGE_REPAYMENTS_INCREASE_ROUTE, MANAGE_ARREARS_ROUTE } from "./containers/IncreaseRepayments/route.constants";

export const ManageRepaymentsRouter = ({ accountId }) => {
  const { path } = useRouteMatch();

  return (
    <ManageRepaymentsButtonContainer>
      <Switch>
        <Route exact path={path}>
          <ManageRepaymentOptions accountId={accountId} />
        </Route>
        <Route path={path + MANAGE_REPAYMENTS_INCREASE_ROUTE.INCREASE}>
          <ManageRepaymentsIncrease accountId={accountId} />
        </Route>
        <Route path={path + MANAGE_ARREARS_ROUTE.ARREARS}>
          <ManageArrearsOptions accountId={accountId} />
        </Route>
      </Switch>
    </ManageRepaymentsButtonContainer>
  );
};